import backend from '@common/backend';

const BASE = '/students/lessons';

export const getStudentLesson = (scheduleLessonId: number, params?: any) =>
	backend.get(`${BASE}/${scheduleLessonId}`, { params });

export const getStudentIndivLesson = (scheduleLessonId: number, params?: any) =>
	backend.get(`${BASE}/indiv/${scheduleLessonId}`, { params });
